import facebookImg from '@assets/facebook-logo.svg';
import { signInWithFacebook } from '@libraries/firebase';
import Image from 'next/legacy/image';
import styled from 'styled-components';

const FacebookButtonWrapper = styled.button`
  align-items: center;
  background: none;
  border: none;
  color: ${(props) => props.theme.grey.blacken(0.2).string()};
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: color 300ms;

  &:active,
  &:hover {
    color: ${(props) => props.theme.navy.mix(props.theme.cyan).string()};
  }

  span {
    margin: 0 0.7rem;
  }
`;

interface FacebookButtonProps {
  text: string;
}

export function FacebookButton({ text }: FacebookButtonProps) {
  return (
    <FacebookButtonWrapper onClick={signInWithFacebook} type="button">
      <Image alt="Facebook Logo" src={facebookImg} />
      <span>{text} with Facebook</span>
    </FacebookButtonWrapper>
  );
}
